import styled from 'styled-components'

const ContentPage = styled.div`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
`

export { ContentPage }
